export default __webpack_public_path__ + "static/media/5.5837f3e2.png";